import type { Dispatch, SetStateAction } from "react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";

type ShowMoreLessButtonProps = {
  showAll?: boolean;
  setShowAll?: Dispatch<SetStateAction<boolean>>;
  onClick?: () => void;
  isLoading?: boolean;
};

export function ShowMoreLessButton({
  showAll,
  setShowAll,
  onClick,
  isLoading,
}: ShowMoreLessButtonProps) {
  const isPaginated = !!onClick;
  const isExpanded = !isPaginated && !!showAll;

  return (
    <Flex justify={{ base: "center", sm: "start" }} align={"center"} gap={2}>
      <Button
        variant={"link"}
        color={"grey.700"}
        fontSize={"lg"}
        fontWeight={600}
        lineHeight={"24px"}
        pl={{ base: 0, sm: 2 }}
        isLoading={isLoading}
        // this is needed for testcases
        aria-label={isPaginated ? "Show more requests" : undefined}
        rightIcon={
          <ChevronDownIcon
            boxSize={6}
            color={"grey.700"}
            ml={-2}
            sx={{
              transition: "transform 0.3s ease-in-out",
              transform: isExpanded ? "rotate(180deg)" : "rotate(0)",
            }}
          />
        }
        onClick={() => (isPaginated ? onClick() : setShowAll?.(!showAll))}
      >
        Show {isExpanded ? "less" : "more"}
      </Button>
    </Flex>
  );
}
